import React, { Component } from "react";
import {transformCloudinary, transformLocal} from '../../modules/utils'
import config from "../../config/config";
import PropTypes from "prop-types";

const { cloudinary } = config;

class Photo extends Component {
  urlTransform = img => {
    const { width, height, crop, quality } = this.props;

    return `${cloudinary.baseUrl}/${
      cloudinary.widget.cloudName
    }/image/upload/f_auto,q_auto/c_${crop},h_${height},q_${quality},w_${width}/v1/${
      img.publicId
    }.jpg`;
  };

  urlTransform = (img) => {
    const {cloudinary} = config
    let uri = ""
    const { width, height, crop, quality } = this.props;
    const size = { width, height, crop, quality };
    switch (img.source) {
      case 'local':
        uri = transformLocal(img, size)
        break
      default:
        size.crop = "fit"
        uri = transformCloudinary(img, cloudinary, size)
        break
    }
    return `${uri}`
  }

  render() {
    let { img, className, onClick, title } = this.props;
    let extra = {};
    if (!title) {
      title = "";
    }
    if (title.length < 2) {
      title = img.title;
    }
    if (onClick) {
      extra.onClick = onClick;
    }
    return (
      <img
        src={this.urlTransform(img)}
        alt={img.title}
        className={className}
        title={title}
        {...extra}
      />
    );
  }
}

Photo.propTypes = {
  img: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  quality: PropTypes.number,
  crop: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string
};

Photo.defaultProps = {
  quality: cloudinary.quality,
  crop: "fit",
  className: "photo",
  title: ""
};

export default Photo;
